export let appStatusBetaTag = "Zgytde";
export let appStatusPreviewTag = "zs7zId";
export default {appStatusBetaTag,appStatusPreviewTag};